<template>
  <div class="table-responsive">
    <table class="table table-striped table-hover custom-fixed-table">
      <thead class="bg-light">
        <tr>
          <th style="width: 12%;">Nombre</th>
          <th style="width: 12%;">Apellido</th>
          <th style="width: 25%;">Posiciones</th>
          <th style="width: 10%;">DNI</th>
          <th style="width: 11%;">Tel. Laboral</th>
          <th style="width: 11%;">Tel. Personal</th>
          <th style="width: 19%;">Email</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(user, index) in users" :key="index">
          <td>{{ user.name }}</td>
          <td>{{ user.lastname }}</td>
          <td>
            <ul class="mb-0 pl-3">
              <li v-if="!user.positions || user.positions.length === 0">N/A</li>
              <li v-for="p in user.positions" :key="p.id">
                {{ p.name }} ({{ p.area?.name || "Sin área" }})
              </li>
            </ul>
          </td>
          <td>{{ user.dni }}</td>
          <td>{{ user.business_phone || 'N/A' }}</td>
          <td>{{ user.personal_phone || 'N/A' }}</td>
          <td>{{ user.email }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    users: {
      type: Array,
      required: true,
      default: () => []
    }
  }
}
</script>

<style scoped>
.table-responsive {
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #dee2e6;
  border-radius: 4px;
}

.table thead th {
  position: sticky;
  top: 0;
  background: #f8f9fa;
  z-index: 1;
}

.table-hover tbody tr:hover {
  background-color: #f8f9fa;
}

.custom-fixed-table {
  table-layout: fixed;
  width: 100%;
  min-width: 800px;
}

.custom-fixed-table td {
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}
</style>